import * as types from "./types";

// Create Client
export const createClientRequest = (payload) => ({
  type: types.CREATE_CLIENT_REQUEST,
  payload,
});

export const createClientResponse = (payload) => ({
  type: types.CREATE_CLIENT_RESPONSE,
  payload,
});

// List Clients
export const getClientsRequest = (payload) => ({
  type: types.GET_CLIENTS_REQUEST,
  payload,
});

export const getClientsResponse = (payload) => ({
  type: types.GET_CLIENTS_RESPONSE,
  payload,
});

// Get Client by ID
export const getClientRequest = (id) => ({
  type: types.GET_CLIENT_REQUEST,
  payload: id,
});

export const getClientResponse = (payload) => ({
  type: types.GET_CLIENT_RESPONSE,
  payload,
});

// List All Clients
export const getAllClientsRequest = () => ({
  type: types.GET_ALL_CLIENTS_REQUEST,
});

export const getAllClientsResponse = (payload) => ({
  type: types.GET_ALL_CLIENTS_RESPONSE,
  payload,
});

// Update Client
export const updateClientRequest = (payload) => ({
  type: types.UPDATE_CLIENT_REQUEST,
  payload,
});

export const updateClientResponse = (payload) => ({
  type: types.UPDATE_CLIENT_RESPONSE,
  payload,
});
